import { makeAutoObservable } from "mobx";
import { Availability } from "../Availability";
/**
 * How and where should the order be fulfilled for Online order.
 */
export class OnlineFulfillmentInstructions {
    constructor(params) {
        this.type = "Online";
        this.deliveryAddress = params.deliveryAddress;
        this.fulfillmentMethodType = params.fulfillmentMethodType;
        this.fulfillmentTime = params.fulfillmentTime;
        this.userNote = params.userNote;
        this.paymentMedium = params.paymentMedium;
        this.paymentMediumRestored = params.paymentMediumRestored;
        makeAutoObservable(this);
    }
    get isEmpty() {
        return (this.deliveryAddress.isEmpty &&
            this.userNote.isEmpty &&
            this.paymentMedium === null);
    }
    get streetAddress() {
        return this.deliveryAddress.streetAddress;
    }
    get apartmentInfo() {
        return this.deliveryAddress.apartmentInfo;
    }
    get isDelivery() {
        return (this.fulfillmentMethodType === "Delivery" ||
            this.fulfillmentMethodType === "NoContactDelivery");
    }
    get paymentAvailability() {
        return Availability.boolean({
            PaymentMediumMissing: this.paymentMedium === null,
        });
    }
    get fulfillmentTimeAvailability() {
        return this.fulfillmentTime !== null
            ? this.fulfillmentTime.availability
            : Availability.unavailable("FulfillmentTimeMissing");
    }
    get fulfillmentMethodTypeAvailability() {
        return Availability.boolean({
            FulfillmentMethodTypeMissing: this.fulfillmentMethodType === null,
        });
    }
    get deliveryAvailability() {
        return this.isDelivery
            ? this.deliveryAddress.availability
            : Availability.available();
    }
    get availability() {
        return Availability.composite([
            this.fulfillmentTimeAvailability,
            this.fulfillmentMethodTypeAvailability,
            this.deliveryAvailability,
            this.userNote.availability,
            this.paymentAvailability,
        ]);
    }
    get fulfillmentMethodCheckoutData() {
        // TODO: default fulfillmentMethodType?
        if (!this.fulfillmentMethodType) {
            return {
                tag: "DineIn",
                location: null,
            };
        }
        switch (this.fulfillmentMethodType) {
            case "Delivery":
                return {
                    tag: this.fulfillmentMethodType,
                    deliveryAddress: this.deliveryAddress.checkoutData,
                    customDeliveryPrice: null,
                };
            case "NoContactDelivery":
                return {
                    tag: this.fulfillmentMethodType,
                    deliveryAddress: this.deliveryAddress.checkoutData,
                };
            case "DineIn":
                return {
                    tag: this.fulfillmentMethodType,
                    location: null,
                };
            case "Takeaway":
                return {
                    tag: this.fulfillmentMethodType,
                };
        }
    }
    get paymentMethod() {
        // TODO: default payment medium / method?
        if (!this.paymentMedium) {
            return "Cash";
        }
        switch (this.paymentMedium.type) {
            case "method":
                return this.paymentMedium.method;
            case "channel":
                return "Online";
        }
    }
    /**
     * @returns data to be sent to the backend
     */
    get checkoutData() {
        return {
            fulfillmentMethod: this.fulfillmentMethodCheckoutData,
            paymentMethod: this.paymentMethod,
            requestedFulfillmentTime: this.fulfillmentTime !== null
                ? this.fulfillmentTime.checkoutData
                : null,
            userNote: this.userNote.checkoutData,
        };
    }
    get fulfillmentMethod() {
        if (this.fulfillmentMethodType === "NoContactDelivery") {
            return "Delivery";
        }
        return this.fulfillmentMethodType;
    }
    get paymentData() {
        if (this.paymentMedium !== null && this.paymentMedium.type === "channel") {
            return {
                applePayToken: null,
                channel: this.paymentMedium.channelId,
                blikCode: null,
                cardToken: null,
                isIosApp: false,
            };
        }
        return null;
    }
}
